import { apiRequest } from './client';
import type { BreakEvenConfigView, HomeSummary, MySubmissions, OwnerDashboardMetadata, OwnerDashboardSummary, OwnerDashboardSummaryFilters, OwnerOverview, PendingSummary } from '../types/dashboard';

const PATH = '/api/dashboard/owner';

export const getOwnerDashboardSummary = (filters: OwnerDashboardSummaryFilters) => apiRequest<OwnerDashboardSummary>(`${PATH}/summary${toQuery(filters)}`);
export const getOwnerDashboardMetadata = () => apiRequest<OwnerDashboardMetadata>(`${PATH}/metadata`);
// Panel de Pendientes (Inicio): conteos accionables. OWNER/MANAGER (el backend gatea cada fuente).
export const getPendingSummary = () => apiRequest<PendingSummary>('/api/dashboard/pending-summary');
// Lado del empleado: estado de lo que él envió (propuestas/anulaciones).
export const getMySubmissions = () => apiRequest<MySubmissions>('/api/dashboard/my-submissions');
// Ola 2: resumen del Inicio (pendientes + hoy/meta/semana + insumos por acabarse) en una llamada.
export const getHomeSummary = () => apiRequest<HomeSummary>('/api/dashboard/home-summary');
/**
 * Owner Intelligence v1 — "Así va tu negocio". Sin rango: mes en curso hasta hoy (Inicio). Con
 * rango: Reportes v2 R1/R2. Llamada aparte del home-summary a propósito: si este bloque falla, el
 * resto del Inicio (pendientes, agotamiento) sigue en pie.
 *
 * Resuelve a `undefined` con 204 — el actor no tiene bloque financiero ni explicación que dar
 * (EMPLOYEE): el Inicio simplemente no lo pinta.
 */
export const getOwnerOverview = (range?: { dateFrom: string; dateTo: string }) =>
  apiRequest<OwnerOverview | undefined>(`/api/dashboard/owner-overview${range ? toQuery(range) : ''}`);
// Ola 2: configuración del punto de equilibrio (solo OWNER; el backend lo exige).
export const getBreakEvenConfig = () => apiRequest<BreakEvenConfigView>('/api/dashboard/break-even-config');
export const setBreakEvenConfig = (input: { monthlyFixedCosts: number; daysOpenPerMonth: number; grossMarginPercent: number }) =>
  apiRequest<BreakEvenConfigView>('/api/dashboard/break-even-config', { method: 'PUT', body: JSON.stringify(input) });

function toQuery(filters: object) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => { if (value !== undefined && value !== '') query.set(key, String(value)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = query.toString();
  return search ? `?${search}` : '';
}
